import { useStoreHook } from "./index"; // Import the hook to access the Zustand state

export const setSliceState = (slice, update) => {
  // Use the set function from Zustand's store to update the state
  useStoreHook.setState((state) => ({
    [slice]: {
      ...state[slice],
      ...update,
    },
  }));
};
